import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DatasourceService } from '@app/core/services';
import { IntlService } from '@progress/kendo-angular-intl';
import { PDFExportComponent } from "@progress/kendo-angular-pdf-export";
import { State } from '@progress/kendo-data-query';
import { ZonedDate } from "@progress/kendo-date-math";
import { environment } from '@environments/environment';


@Component({
  selector: 'liberacion-report',
  template: `    
    <div style="position: absolute; left: -90000px; top: -90000px;">
    <!--<div>-->
      <kendo-pdf-export #pdf paperSize="Letter" margin="2cm" [scale]="0.5" [landscape]="false" forcePageBreak=".page-break">    

        <ng-template kendoPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <div class="footerDate">Fecha: {{ print_date | kendoDate: "d MMM y HH:mm:ss" }}</div>
          <div class="footerPageNum">Página {{ pageNum }} de {{ totalPages }}</div>
        </ng-template>

        <div class="header">GRÚAS DELHER</div>
        <div class="header">SUC: {{branchName | uppercase}}</div>        
        <div class="header">LIBERACIÓN EXP. {{contextItem.sku_exp}} / {{contextItem.sku_inv}}</div>
        <!--<div class="header header-last">FECHA: {{ date }}</div>-->

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-3 text-center">
              Folio de inventario
              <p class="text-lg"><b>{{contextItem.sku_inv}}</b></p>  
            </div>
            <div class="col-sm-3 offset-sm-6 text-center">
              Folio de expediente
              <p class="text-lg negative"><b>{{contextItem.sku_exp}}</b></p>
            </div>
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-12 text-center bg-secondary text-white p-2">
              INFORMACIÓN DE ENTRADA / SALIDA            
            </div>
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-4 text-center">
              Fecha de entrada
              <p><b>{{formatDate(contextItem.entry_date)}}</b></p>
            </div>
            <div class="col-sm-4 text-center">
              Fecha de salida              
              <p><b>{{formatDate(contextItem.output_date)}}</b></p>  
            </div>
            <div class="col-sm-4 text-center">
              Días
              <p><b>{{contextItem.days}}</b></p>  
            </div>
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-8 text-center">
              Autoridad
              <p><b>{{contextItem.authority_name}}</b></p>
            </div>
            <div class="col-sm-4 text-center">
              Depósito
              <p><b>{{contextItem.deposit_name}}</b></p>
            </div>
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-12 text-center bg-secondary text-white p-2">
              INFORMACIÓN DEL VEHÍCULO              
            </div>
          </div>
        </div>

        <div class="wathermark">
          <p>LIBERADO</p>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-12 text-center">
              Tipo de vehículo
              <p><b>{{contextItem.vehicle_type_name}}</b></p>
            </div>            
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-3 text-center">
              Marca
              <p><b>{{contextItem.marck}}</b></p>
            </div>
            <div class="col-sm-3 text-center">
              Color
              <p><b>{{contextItem.color}}</b></p>
            </div>
            <div class="col-sm-3 text-center">
              Placas
              <p><b>{{contextItem.plaque}}</b></p>
            </div>
            <div class="col-sm-3 text-center">
              Número de serie
              <p><b>{{contextItem.serie}}</b></p>
            </div>
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-12 text-center">
              Lugar
              <p><b>{{contextItem.place}}</b></p>
            </div>           
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-12 text-center">
              Observaciones
              <p><b>{{contextItem.observations}}</b></p>
            </div>           
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-12 text-center bg-secondary text-white p-2">
              DESGLOSE DE COSTOS
            </div>
          </div>
        </div>

        <div class="container pt-4">
          <div class="row">
            <div class="col-sm-9 text-right">Costo de grúa:</div>
            <div class="col-sm-3 text-right text-currency text-currency-sm"><b>{{intl.formatNumber(contextItem.cost_crane, 'c2')}}</b></div>
          </div>
          <div class="row">
            <div class="col-sm-9 text-right">Costo de pensión: ({{contextItem.days}} días x {{intl.formatNumber(contextItem.vehicle_type_fee, 'c2')}})</div>
            <div class="col-sm-3 text-right text-currency text-currency-sm"><b>{{intl.formatNumber(contextItem.cost_pension, 'c2')}}</b></div>
          </div>
          <div class="row">
            <div class="col-sm-9 text-right">Subtotal:</div>
            <div class="col-sm-3 text-right text-currency text-currency-sm"><b>{{intl.formatNumber(contextItem.cost_subtotal, 'c2')}}</b></div>
          </div>
          <div class="row">
            <div class="col-sm-9 text-right">I. V. A.: (16%)</div>
            <div class="col-sm-3 text-right text-currency text-currency-sm"><b>{{intl.formatNumber(contextItem.cost_iva, 'c2')}}</b></div>
          </div>
          <div class="row">
            <div class="col-sm-9 text-right">Costo Total:</div>
            <div class="col-sm-3 text-right text-currency text-currency-sm"><b>{{intl.formatNumber(contextItem.cost_total, 'c2')}}</b></div>
          </div>
          <div class="row" *ngIf="contextItem.cost_discount_perc != 0">
            <div class="col-sm-9 text-right">Descuento: ({{intl.formatNumber(contextItem.cost_discount_perc, 'p2')}}):</div>
            <div class="col-sm-3 text-right text-currency text-currency-sm negative"><b>-{{intl.formatNumber(contextItem.cost_discount, 'c2')}}</b></div>
          </div>
          <div class="row mt-2">
            <div class="col-sm-9 text-right pt-3">Pagado ({{contextItem.payment_type_name}}):</div>
            <div class="col-sm-3 text-right text-currency text-lg" style="border-top: 1px solid black;"><b>{{intl.formatNumber(contextItem.cost_paid, 'c2')}}</b></div>
          </div>
        </div>

        <div class="container" style="padding-top: 120px;">
          <div class="row">
            <div class="col-sm-12 text-center">
              Autoriza
              <p><b>{{contextItem.person_name}}</b></p>
            </div>           
          </div>
        </div>

        <div *ngIf="photos.length != 0" class="container page-break pt-4">
          <div class="row">
            <div class="col-sm-12 text-center bg-secondary text-white p-2">
              REPORTE FOTOGRÁFICO
            </div>
          </div>
        </div>

        <div *ngIf="photos.length != 0" class="container pt-4" style="padding-left: 0; padding-right: 0;">
          <div class="row">
            <div *ngFor="let item of photos; index as i" class="col-sm-4 pb-4">
              <img width="100%" src='{{item.secure_photo}}'/>
            </div>           
          </div>
        </div>

      </kendo-pdf-export>
    <div>`,
  styleUrls: ["./styles/pdf-styles.css", "./styles/report-styles.css"],
  styles: [`
    .footerPageNum {
      position: absolute;
      right: 120px;
      bottom: 120px;
    }
    .footerDate {
      position: absolute;
      left: 120px;
      bottom: 120px;
    }
    .wathermark {
      font-size: 175px;
      font-weight: bolder;
      color: rgba(0, 0, 0, .10);
      position: absolute;      
      transform:rotate(-60deg);
      -ms-transform:rotate(-60deg); /* IE 9 */
      -webkit-transform:rotate(-60deg); /* Opera, Chrome, and Safari */}
    }
  `]
})
export class LiberacionReportComponent implements OnInit {

  //ExcelExport
  @ViewChild('pdf', {static: false}) pdf !: PDFExportComponent;
  
  public name: string = 'report';

  protected branchName: string = environment.branchName;

  protected scale: number = 0.5;

  protected id = 0;
  protected contextItem: any = {};
  protected photos: any = [];
  protected print_date = null;


  constructor(protected service : DatasourceService, protected intl: IntlService) { 

  }

  public download(id: any, contextItem: any) {

    let that = this;

    this.id = id;
    this.contextItem = contextItem;
    this.print_date = new Date();
    
    let state : State = {
      skip: 0, 
      take: 0, 
      // sort: [{field: 'sku_exp', dir: 'desc'}], 
      filter: {
        logic: "and",
        filters: [
            {
                field: 'id_vehicle_inventory',
                operator: 'eq',
                value: this.id
            }
        ]
      }, 
      group: []
    }

    this.service.get('vehicles_inventories_photos', state)
      .subscribe(
        (res) => {
          console.log("RESPONSE------: ", res);
          this.photos = res.data.map(function(item, i){
            return {
              ...item,
              secure_photo: item.photo.replace('http://', 'https://')
            }
          });    
        },
        (fail) => {        
          console.log("Error", fail);
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        setTimeout(function(){
          that.pdf.saveAs(`${that.name}.pdf`)
        }, 100);
      });
    
  }

  public formatDate(date: string) : string {
    const tzDate = ZonedDate.fromUTCDate(new Date(date), environment.timezone);
    let d: Date = new Date(tzDate.toUTCString().replace('Dev', 'Dec'))
    return this.intl.formatDate(d, "d MMM y");
  }

  ngOnInit() {

  }

}
